import { render, staticRenderFns } from "./ruler-ver.vue?vue&type=template&id=cc12783e&scoped=true&"
import script from "./ruler-ver.vue?vue&type=script&lang=js&"
export * from "./ruler-ver.vue?vue&type=script&lang=js&"
import style0 from "./ruler-ver.vue?vue&type=style&index=0&id=cc12783e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc12783e",
  null
  
)

export default component.exports